import { createContext } from 'react';

import marketplace from 'cfg/marketplace.json';

export const MartyContext = createContext({
  testId: () => null,
  marketplace,
  router: {}
});
